import { createFileRoute } from "@tanstack/react-router";

function SupportPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-md mx-auto bg-white rounded-lg shadow-sm p-8">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">고객 지원</h1>

        <div className="space-y-6">
          <section>
            <h2 className="text-lg font-semibold text-gray-800 mb-2">
              그로잉어학원
            </h2>
            <p className="text-gray-600">
              그로잉어학원 교사용 웹에 대한 문의사항이 있으시면 아래 연락처로
              문의해 주세요.
            </p>
          </section>

          <section>
            <h3 className="text-sm font-medium text-gray-500 mb-1">
              이메일 문의
            </h3>
            <a
              href="mailto:growingeng.dev@gmail.com"
              className="text-blue-600 hover:underline"
            >
              growingeng.dev@gmail.com
            </a>
          </section>

          <section className="pt-4 border-t border-gray-200">
            <h3 className="text-sm font-medium text-gray-500 mb-2">
              자주 묻는 질문
            </h3>
            <ul className="text-gray-600 text-sm space-y-2">
              <li>
                <strong>Q. 로그인이 안 돼요.</strong>
                <br />
                학원에서 발급받은 계정 정보를 확인해 주세요.
              </li>
              <li>
                <strong>Q. 비밀번호를 잊었어요.</strong>
                <br />
                로그인 페이지에서 비밀번호 초기화를 시도해 주세요.
              </li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
}

export const Route = createFileRoute("/support")({
  component: SupportPage,
});
